module.exports = "<p>\n  transparent works!\n</p>\n"